/* prettier-ignore */

import { Component, Input, ViewEncapsulation} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PDFViewerComponent } from '../pdf-viewer/pdf-viewer.page';
import { Router } from '@angular/router';
import { IDatasource } from 'ngx-ui-scroll';

@Component({
  selector: 'cicerone-list-cards',
  templateUrl: './list-cards.component.html',
  styleUrls: ['./list-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ListCardsComponent {
  @Input() item?: any;
  
  private _imageCounter = 0; // Counter for cycling through 1-4
  private _currentNameSlug = ''; // Track current category to reset counter
  private _itemImageMap = new Map<string, number>(); // Cache images per item

  datasource: IDatasource = {
    get: (index, count, success) => {
      const data = [];
      for (let i = index; i <= index + count - 1; i++) {
        if (this.item?.items?.length > i)
          data.push({type: 'item', data: this.item.items[i]});
        // else if (this.item?.items?.length === i)
        //   data.push({type: 'more', data: []})
      }
      success(data);
    },
    settings: {
      horizontal: true,
      minIndex: 0,
      startIndex: 0
    }
  };

  constructor(
    public translate: TranslateService, 
    public modalCtrl: ModalController, 
    private router: Router,
  ) {}
  
  async openModalPDF(pdf){
    const modal = await this.modalCtrl.create({
      component: PDFViewerComponent,
      cssClass: 'pdfModal',
      componentProps: { pdf: pdf.url[this.translate.currentLang], name: pdf.name[this.translate.currentLang], id: pdf.id }
    });
    await modal.present();
  }

  goToSubCategoriesList(item){
    this.router.navigate([`/${item.nameSlug[this.translate.currentLang]}/${item.id}`]);
  }

  public getDefaultImgFileName(nameSlug: string, itemId: string): string {
    // Create unique key for this item
    const itemKey = `${nameSlug}-${itemId}`;
    
    // Return cached image if exists
    if (this._itemImageMap.has(itemKey)) {
      const imageNumber = this._itemImageMap.get(itemKey)!;
      return `/assets/imgs/default/category/${nameSlug}/${nameSlug}-${imageNumber}.webp`;
    }
    
    // Reset counter if nameSlug changed
    if (this._currentNameSlug !== nameSlug) {
      this._currentNameSlug = nameSlug;
      this._imageCounter = 0;
    }
    
    // Increment counter and cycle between 1-4
    this._imageCounter = (this._imageCounter % 4) + 1;
    
    // Cache the image number for this item
    this._itemImageMap.set(itemKey, this._imageCounter);
    
    return `/assets/imgs/default/category/${nameSlug}/${nameSlug}-${this._imageCounter}.webp`;
  }
}